import axios from "axios";

// export const serverURL = 'http://localhost:8091/api'
export const serverURL = 'VUE_APP_SERVER_URL'

export default axios.create({
  baseURL: serverURL,
  headers: {
    'Content-Type': 'application/json'
  }
})
